/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import broadcast
import Broadcast from '../views/broadcast/Broadcast.vue';
import BroadcastForm from '../views/broadcast/BroadcastForm.vue';
import BroadcastHistory from '../views/broadcast/BroadcastHistory.vue';
import BroadcastLog from '../views/broadcast/BroadcastLog.vue';

import { setBreadcrumb } from './index';

const broadcastRoute = {
  path: '/broadcast',
  name: 'Broadcast',
  children: [
    {
      path: '/broadcast/broadcast',
      meta: {
        title: 'BNI QRIS - Broadcast',
        appBarTitle: 'Broadcast',
        breadcrumbs: () => [
          setBreadcrumb('broadcast management', '/broadcast', true),
          setBreadcrumb('broadcast', '/broadcast/broadcast'),
        ],
      },
      component: Broadcast,
    },
    {
      path: '/broadcast/broadcast/:action/:id?',
      meta: {
        title: 'BNI QRIS - Broadcast',
        appBarTitle: 'Broadcast',
        breadcrumbs: (params) => {
          const { action } = params;
          const { id } = params;
          const crumbs = [
            setBreadcrumb('broadcast management', '/broadcast', true),
            setBreadcrumb('broadcast', '/broadcast/broadcast'),
            setBreadcrumb(action, `/broadcast/broadcast/${action}`, true),
          ];
          if (id != null && id != '') {
            crumbs.push(
              setBreadcrumb(id, `/broadcast/broadcast/${action}/${id}`, true)
            );
          }
          return crumbs;
        },
      },
      component: BroadcastForm,
    },
    {
      path: '/broadcast/broadcast-history',
      meta: {
        title: 'BNI QRIS - Broadcast History',
        appBarTitle: 'Broadcast History',
        breadcrumbs: () => [
          setBreadcrumb('broadcast management', '/broadcast', true),
          setBreadcrumb(
            'broadcast history',
            '/broadcast/broadcast-history',
            true
          ),
        ],
      },
      component: BroadcastHistory,
    },
    {
      path: '/broadcast/broadcast-log',
      meta: {
        title: 'BNI QRIS - Broadcast Log',
        appBarTitle: 'Broadcast Log',
        breadcrumbs: () => [
          setBreadcrumb('broadcast management', '/broadcast', true),
          setBreadcrumb('broadcast Log', '/broadcast/broadcast-log', true),
        ],
      },
      component: BroadcastLog,
    },
  ],
  meta: {
    title: 'BNI QRIS - Broadcast',
    appBarTitle: 'Broadcast',
  },
  component: Parent,
};

export default broadcastRoute;
